import { render, staticRenderFns } from "./Storedvalue.vue?vue&type=template&id=66c15c7f&scoped=true"
import script from "./Storedvalue.vue?vue&type=script&lang=js"
export * from "./Storedvalue.vue?vue&type=script&lang=js"
import style0 from "./Storedvalue.vue?vue&type=style&index=0&id=66c15c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c15c7f",
  null
  
)

export default component.exports